const state = {
  form: {
    receiveAddrid: '',
    othderAddrid: '',
  },
}

const getters = {
}

const mutations = {
  initForm (state, form, rootState) {
    state.form = {
      dgType: 'DP', // DP: 直接付款, PA: 改價
      dgPymtMethod: 'BC',
      dgSource: '',
      bcid: '',
      dgMemo: '',
      receiveAddrid: window.vueApp.$store.state.userData.defaultWhsAddrid || '1598',
      othderAddrid: '',
      addressParam: undefined,
      goods: {
        gsUrl: '',
        dgOrderAmount: '',
      },
    }
  },
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/mx-dg/search', {
      params,
      noShowError: true,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/mx-dg/view', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  batchCreateOrder ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/mx-dg/batch-create-order', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  cancel ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/mx-dg/cancel', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
